document.addEventListener('page:loaded', function() {
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }

  $(".video-thumbnail").click(function() {
    console.log("clicked");
    $(".video-thumbnail-image").css("display", "none");
  });

});

document.addEventListener('Searchanise.Loaded', function () {
  var SearchaniseResponseData;

  (function ($) {
    $(document).on('Searchanise.DataRequestEnd', function (event, type, params, data) {
      SearchaniseResponseData = data;
    });

    $(document).on('Searchanise.ResultsUpdated', function (event, container) {
      SearchaniseResponseData.facets.forEach(function(f){
        if (f.appearance !== "color")
          return;

        f.buckets.forEach(function(b){
          let div = $(".snize-color-filter-checkbox span[title='"+b.title+"']").parent();
          if (!$('.snize-color-count', div).length) {
            div.append('<div class="snize-color-count">'+b.title+'</div>');
          }
        });
      });
    });
  })(window.Searchanise.$);
});